import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import Fonts from "../../../Config/Fonts";
import { AppConstants } from "../../../Constants/AppConstants";
import { useUserRolePermission } from "../../../Context/UserRolePermission/UserRolePermissionState";
import {
  getProductByManufactureIdAPI,
  getProductDetailsAPI,
} from "../../../Store/Action/productAction";
import { getLoggedInUserDetailsAPI } from "../../../Store/Action/UserAction";
import Colors from "../../../theme/Colors";
import ProductTable from "../Component/ProductTable";
import CustomTopView from "../../../Components/CustomTopView";

const ProductList = () => {
  const searchInputRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.user);

  const [products, setProducts] = useState([]);

  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const limit = AppConstants.limit;
  const rowsPerPageOptions = [25, 50, 100];
  const rowsPerPageLabel = "Products Per Page";
  const [pageNumber, setPageNumber] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalCount, setTotalCount] = useState(1);

  const onAddProducts = () => {
    navigate("/addProducts");
  };

  const handleChangePage = useCallback((event, newPage) => {
    setPageNumber(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(event.target.value);
    setPageNumber(0);
  }, []);

  const handleSearchChange = useCallback((event) => {
    setSearchQuery(event.target.value);
    setPageNumber(0);
  }, []);

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/productList", text: "Products" },
      { key: "2", href: "/productList", text: "Product List" },
    ]);
    dispatch(getLoggedInUserDetailsAPI({}));
  }, [dispatch]);

  const onViewProductDetails = useCallback(
    (product) => {
      navigate(`/productDetails/${product?.product_id}`, {
        state: { product },
      });
    },
    [navigate]
  );

  const productRolePermissions = useUserRolePermission();

  useEffect(() => {
    const userDataAPI = async () => {
      try {
        if (userData?.data[0]?.user_role_name === "admin") {
          const params = {
            searchQuery: searchQuery || undefined,
            page: pageNumber || undefined,
            limit: limit || undefined,
          };

          dispatch(
            getProductDetailsAPI(params, (result) => {
             
              setProducts(result?.data || []);
              setTotalCount(result?.totalCount);

              if (searchInputRef.current) {
                searchInputRef.current.focus();
              }
            })
          );
        } else {
   
          dispatch(
            getProductByManufactureIdAPI(
              userData?.data[0]?.user_role_id,
              (result) => {
                
                setProducts(result?.data || []);
              }
            )
          );
        }
      } catch (error) {
        console.log("Failed to fetch products:", error);
      }
    };
    userDataAPI();
  }, [
    dispatch,
    limit,
    pageNumber,
    searchQuery,
    userData?.data[0]?.user_role_id,
    userData?.data[0]?.user_role_name,
  ]);

  return (
    <div style={mainContainerStyle}>
      <LeftSideNav />
      <div
        style={{
          backgroundColor: "#F0F5FF",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          paddingRight: "20px",
        }}
      >
        <TopNavBar
          leftSideText={`Hello ${userData?.data?.user_first_name}`}
          isDashboard={true}
        />

        <CustomTopView
          breadcrumbs={breadcrumbs}
          addButtonText={"Add Product"}
          exportButtonText={"Export Product"}
          rowsPerPage={rowsPerPage}
          handleRowsPerPageChange={handleChangeRowsPerPage}
          rowPerPageLabel={rowsPerPageLabel}
          onAddButtonClick={onAddProducts}
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
        />

        <ProductTable
          products={products}
          onAddProduct={onAddProducts}
          page={pageNumber}
          rowsPerPage={rowsPerPage}
          handlePageChange={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          totalItems={totalCount}
          rowsPerPageOptions={rowsPerPageOptions}
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
          rowsPerPageLabel={rowsPerPageLabel}
          onViewProductDetails={onViewProductDetails}
          productRolePermission={productRolePermissions}
        />
      </div>
    </div>
  );
};
const mainContainerStyle = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100vh",
  width: "100vw",
  overflowX: "hidden",
  overflowY: "hidden",
};

const mainHeadingStyle = {
  fontSize: 24,
  fontWeight: 700,
  fontFamily: Fonts.Poppins,
  color: Colors.black,
};

export default ProductList;
